export const Check = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.76922 6.88227C1.76939 4.05642 4.06034 1.76576 6.88619 1.76593L17.1166 1.76655C19.9424 1.76672 22.2331 4.05766 22.2329 6.88351L22.2323 17.1139C22.2321 19.9397 19.9412 22.2304 17.1153 22.2302L6.88495 22.2296C4.0591 22.2294 1.76844 19.9385 1.76861 17.1126L1.76922 6.88227Z'
      fill='#7B7BDF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.999645 6.88415C0.999841 3.63442 3.63443 1.00016 6.88416 1.00035L17.1145 1.00097C20.3643 1.00117 22.9985 3.63575 22.9983 6.88547L22.9977 17.1158C22.9975 20.3655 20.3629 22.9998 17.1132 22.9996L6.88283 22.999C3.6331 22.9988 0.998833 20.3642 0.999029 17.1145L0.999645 6.88415ZM6.88406 2.53535C4.48209 2.53521 2.53479 4.48227 2.53464 6.88424L2.53403 17.1146C2.53388 19.5166 4.48095 21.4639 6.88292 21.464L17.1133 21.4646C19.5153 21.4648 21.4626 19.5177 21.4627 17.1157L21.4633 6.88538C21.4635 4.48341 19.5164 2.53611 17.1144 2.53597L6.88406 2.53535Z'
      fill='#7B7BDF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.1142 8.46214C16.4533 8.71646 16.522 9.19753 16.2677 9.53664L11.9605 15.2795C11.6236 15.7287 10.9558 15.7458 10.5964 15.3145L7.75603 11.906C7.48467 11.5804 7.52867 11.0965 7.8543 10.8251C8.17993 10.5537 8.66389 10.5977 8.93525 10.9234L11.2372 13.6856L15.0397 8.61564C15.294 8.27654 15.7751 8.20781 16.1142 8.46214Z'
      fill='white'
    />
  </svg>
)
